import { TilføjPunkt } from "./TilføjPunkt";
import "./TilføjPunkt.scss";

export default TilføjPunkt;
